

export const LandingHeaderNavigation = ({ setShowSidebar}) =>{


  const handleClick = () => {
    if(setShowSidebar){
      setShowSidebar(false)
    }
  }

    return (<nav className="flex flex-col md:flex-row md:justify-evenly items-start p-4 w-full text-xl text-gray-500">
              
              <a 
                href="/" 
                className="block py-2 hover:text-indigo-600"
                onClick={handleClick}>
                Home
              </a>
              <a 
                href="#features" 
                className="block py-2 hover:text-indigo-600"
                onClick={handleClick}>
                Features
              </a>
              <a
                href="#how-it-works"
                className="block py-2 hover:text-indigo-600"
                onClick={handleClick}
              >
                How It Works
              </a>
              {/* <a
                href="#testimonials"
                className="block py-2 hover:text-indigo-600"
                onClick={handleClick}
              >
                Testimonials
              </a> */}
    </nav>)
}